$(document).ready(function () {
    const enabled_routes = [
        'contracts.edit'
    ];

    if (!enabled_routes.includes(route().current())) {
        return;
    }

    let $not_exist_number = $('#not_exist_number');

    //region Form Invio Mail
    $('#mail-form-modal').on('hidden.bs.modal', function () {
        const iframe_mail = document.getElementById('iframe-mail');
        iframe_mail.src = iframe_mail.src;
    });
    //endregion

    $('#number').on('keyup', function () {
        if(!$(this).val()){
            $not_exist_number.prop('checked', true);
        } else{
            $not_exist_number.prop('checked', false);
        }
    });
});
